import { render, staticRenderFns } from "./AddPopupSide.vue?vue&type=template&id=a4bd826a&scoped=true"
import script from "./AddPopupSide.vue?vue&type=script&lang=js"
export * from "./AddPopupSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd826a",
  null
  
)

export default component.exports